var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDownload = function SvgDownload(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.222 1.778v7.454L5.44 7.45a.778.778 0 0 0-1.1 1.1l3.111 3.11a.78.78 0 0 0 1.1 0l3.11-3.11a.778.778 0 1 0-1.098-1.1L8.778 9.232V1.778a.778.778 0 1 0-1.556 0m6.222 10.888v-1.555a.778.778 0 0 1 1.556 0v1.555A2.333 2.333 0 0 1 12.667 15H3.333A2.333 2.333 0 0 1 1 12.666v-1.555a.778.778 0 1 1 1.556 0v1.555c0 .43.348.778.777.778h9.334c.43 0 .777-.348.777-.778",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDownload);
export { ForwardRef as ReactComponent };